<template>
  <div class="user-data">
    <div class="user-data__container">
      <h3 class="user-data__title">
        <FontAwesomeIcon :icon="['far', 'user']" />

        {{ $t('landingpage.checkout-page.user-data.title') }}
      </h3>

      <div class="user-data__intro">
        <p>{{ $t('landingpage.checkout-page.user-data.intro') }}</p>
      </div>

      <div class="user-data__form mt-8">
        <CheckoutForm
          :fields="fields"
          :backend="backend"
          :loading="store.loading"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import CheckoutForm from './CheckoutForm.vue'
import { useCheckoutFormStore } from '@landingpage/Registration/composables/useCheckoutFormStore'
import { useVisibilityRules } from '@landingpage/Registration/composables/useVisibilityRules'

const props = defineProps({
  fields: { type: Object, required: true },
  initialFormData: { type: Object, required: true },
})

const emit = defineEmits(['update:formData', 'validation-failed'])

const store = useCheckoutFormStore()
const backend = store.createAdapter()

store.initialize(props.initialFormData, props.fields)

watch(
  () => store.formData,
  (newValue) => emit('update:formData', newValue),
  { deep: true },
)

const validate = () => {
  if (!props.fields?.items) return true

  const { evaluateVisibilityRules } = useVisibilityRules(store.formData)
  const visibleFields = props.fields.items.filter((item) => {
    if (item.hidden) return false
    if (!item.visibility_rules) return true
    return evaluateVisibilityRules(item.visibility_rules)
  })

  // Only validate visible fields
  const isValid = store.validate(visibleFields)
  if (!isValid) emit('validation-failed', store.errors)

  return isValid
}

const getPayload = () => store.formData
const setApiErrors = (errors) => store.setErrors(errors)
const reset = () => store.reset()

defineExpose({
  validate,
  getPayload,
  setApiErrors,
  reset,
})
</script>
